import { render, staticRenderFns } from "./UpdateExt.vue?vue&type=template&id=71233f22"
import script from "./UpdateExt.vue?vue&type=script&lang=js"
export * from "./UpdateExt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports